import { SelectItem } from "primeng/api";

enum FormEventType {
    CreateEpisode = 1,
    CreatePrescription ,
    ApproveWalkIn,
    SaveNote,
    SaveDocument,
    CreatePatient,
    SelfRegisterPatient,
    BookAppointment,
    CreateTestOrder,
    ReviewPatient,
    DailyListAddMedication
}

const FormEventTypeMap: { [key: number]: string } = {};
FormEventTypeMap[FormEventType.CreateEpisode] = "Create Episode";
FormEventTypeMap[FormEventType.CreatePrescription] = "Create Prescription";
FormEventTypeMap[FormEventType.ApproveWalkIn] = "Approve WalkIn";
FormEventTypeMap[FormEventType.SaveNote] = "Save Note (Create)";
FormEventTypeMap[FormEventType.SaveDocument] = "Save Document (Create)";
FormEventTypeMap[FormEventType.CreatePatient] = "Create Patient";
FormEventTypeMap[FormEventType.SelfRegisterPatient] = "Self-Register Patient";
FormEventTypeMap[FormEventType.BookAppointment] = "Book Appointment";
FormEventTypeMap[FormEventType.CreateTestOrder] = "Create Test Order";
FormEventTypeMap[FormEventType.ReviewPatient] = "Review Patient";
FormEventTypeMap[FormEventType.DailyListAddMedication] = "Daily List: Add Medication";


const createOptions = () =>
    Object.keys(FormEventType)
        .filter(k => !isNaN(+k))
        .map(dt => <SelectItem>{ label: FormEventTypeMap[dt], value: dt });

export { FormEventType, FormEventTypeMap, createOptions };
